<p-floatLabel>
  <p-select #evaluationTemplatesDropdown
    id="evaluationTemplatesDropdown"
    name="evaluationTemplatesDropdown"
    [options]="evaluationTemplates"
    [(ngModel)]="evaluationTemplateSelected"
    [showClear]="!isRequired"
    [checkmark]="true"
    [disabled]="isReadOnly"
    [appendTo]="'body'"
    [filter]="true"
    filterBy="name"
    styleClass="w-100"
    optionLabel="name"
    (onChange)="onSelected()">
    <ng-template let-option pTemplate="item">
      {{ option.name }}
    </ng-template>
  </p-select>
  <label for="evaluationTemplatesDropdown">
    <app-label-content [isRequired]="isRequired">
      {{ l('::Template') }}
    </app-label-content>
  </label>
</p-floatLabel>

@if(showAreasAssociated && isDefined(evaluationTemplateSelected)) {
  <div class="row justify-content-center mt-4">
    <div class="col-6">
      <p-floatLabel>
        <input #areaNameInput="ngModel"
          pInputText 
          class="w-100"
          type="text"
          [(ngModel)]="evaluationTemplateSelected.areaName"
          name="areaNameInput"
          disabled/>

        <label for="areaNameInput">
          <app-label-content [isRequired]="true">
            {{ l('::Area') }}
          </app-label-content>
        </label>
      </p-floatLabel>
    </div>

    <div class="col-6">
      <p-floatLabel>
        <input #subAreaNameInput="ngModel"
          pInputText 
          class="w-100"
          type="text"
          [(ngModel)]="evaluationTemplateSelected.subAreaName"
          name="subAreaNameInput"
          disabled/>

        <label for="subAreaNameInput">
          <app-label-content [isRequired]="true">
            {{ l('::SubArea') }}
          </app-label-content>
        </label>
      </p-floatLabel>
    </div>
</div>
}